module.exports = __webpack_public_path__ + "img/instagram-logo.fc6eb00f.png";